import { css } from '@emotion/react';
import { breakpoints, colors } from '../../styles';
import { Primary, p2r } from '../../styles/fonts';

const NAVIGATION_POSITION_TOP = 70;
const BORDER_WIDTH_TRIANGLE = 13;
const MULTIPLIER = 2;
const MENU_BORDER = 1;

const multiply = (height, multiplier) => `${multiplier * height}px`;

const styles = css`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;

  @media (max-width: ${breakpoints.tablet}px) {
    display: none;
  }

  .main-navigation {
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 100%;
  }

  .dropdown-content {
    position: absolute;
    top: ${p2r(42)};
    right: 0;
    z-index: 3;
    display: none;
    padding: ${p2r(24)} 51px;
    cursor: default;
    background-color: ${colors.white};
    border: ${MENU_BORDER}px solid ${colors.blackLight};

    @media (max-width: ${breakpoints.netbook}px) {
      top: ${p2r(17)};
    }
  }

  .dropdown-content-wrapper {
    position: absolute;
    top: ${p2r(NAVIGATION_POSITION_TOP - BORDER_WIDTH_TRIANGLE)};
    display: none;
    width: 30%;
    height: ${multiply(BORDER_WIDTH_TRIANGLE, MULTIPLIER)};
  }

  .dropdown-content::after,
  .dropdown-content::before {
    position: absolute;
    top: ${p2r(-25)};
    right: 60px;
    width: 0;
    content: '';
    border: solid transparent;
  }

  .dropdown-content::before {
    border-width: ${BORDER_WIDTH_TRIANGLE - 1}px;
    border-bottom-color: ${colors.blackLight};
  }

  .dropdown-content::after {
    margin-right: ${-MENU_BORDER}px;
    border-width: ${BORDER_WIDTH_TRIANGLE}px;
    border-bottom-color: ${colors.white};
  }

  .dropdown-content__link {
    padding: 0 ${p2r(20)} 17px;
    font: normal normal 300 ${p2r(18)} / ${p2r(39)} ${Primary};
    line-height: ${p2r(20)};
    color: ${colors.blackLight};
    text-decoration: none;
    white-space: nowrap;

    &:hover {
      text-decoration: underline;
      cursor: pointer;
    }

    &--active {
      font: normal normal bold ${p2r(18)} / ${p2r(28)} ${Primary};
    }
  }

  .dropdown-content__link-wrapper {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-bottom: ${p2r(7)};
  }

  .dropdown-content__link-title {
    font-size: ${p2r(18)};
    font-weight: bold;
    line-height: ${p2r(21)};
    color: ${colors.darkGreen};
    text-decoration: none;
    white-space: nowrap;
  }

  .article-link__arrow {
    display: inline-block;
    padding: 4px;
    margin-left: 12px;
    border: solid ${colors.black};
    border-width: 0 2px 2px 0;
    transition: transform 0.2s ease-out;
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg);
  }

  .article-link {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 ${p2r(18)};
    font: normal normal normal ${p2r(20)} / ${p2r(27)} ${Primary};
    color: ${colors.black};
    text-decoration: none;
    cursor: default;

    &:hover {
      text-decoration: underline;
      cursor: pointer;

      .dropdown-content {
        display: flex;
        flex-direction: column;
      }

      .article-link__arrow {
        transition: transform 0.2s ease-out;
        -webkit-transform: rotate(-135deg);
        transform: rotate(-135deg);
      }

      .dropdown-content-wrapper {
        display: flex;
      }
    }

    &--active {
      font: normal normal bold ${p2r(20)} / ${p2r(27)} ${Primary};
    }
  }
`;

export default styles;
